import { render, staticRenderFns } from "./WorkspaceMenuBar.vue?vue&type=template&id=287051b2&scoped=true"
import script from "./WorkspaceMenuBar.vue?vue&type=script&lang=js"
export * from "./WorkspaceMenuBar.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceMenuBar.vue?vue&type=style&index=0&id=287051b2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287051b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('287051b2')) {
      api.createRecord('287051b2', component.options)
    } else {
      api.reload('287051b2', component.options)
    }
    module.hot.accept("./WorkspaceMenuBar.vue?vue&type=template&id=287051b2&scoped=true", function () {
      api.rerender('287051b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceMenuBar.vue"
export default component.exports